/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/csv_import_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/csv_import_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  id: common.objectId,
  name: z.string().nullable().optional(),
  created_at: common.time,
  import_is_done: z.boolean().nullable().optional(),
  import_is_filterable: z.boolean().nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/csv_import_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  id: common.objectId,
  name: z.string(),
  created_at: common.time,
  import_is_done: z.boolean(),
  import_is_filterable: z.boolean(),
});
